import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DownloadProgress extends Vue {
  @Prop({default: 0}) value!: number;
  get isDownloading(){
    return this.value > 0 && this.value < 1;
  }
}